import { DateService } from './../../services/date.service';
import { ActivatedRoute, Router } from '@angular/router';
import { VmsService } from './../../services/vms.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-individual-invite-status',
  templateUrl: './individual-invite-status.component.html',
  styleUrls: ['./individual-invite-status.component.scss'],
})
export class IndividualInviteStatusComponent implements OnInit, OnDestroy {
  id: string;
  date: any;
  time: any;
  tempDate: any;
  data: any;

  private subscriptions = new Subscription();

  constructor(private router:Router,private vmsSrv: VmsService,private activatedRoute: ActivatedRoute,private dateSrv: DateService) {}

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((res) => {
      this.id = res.id ? res.id : null;
      this.loadData(this.id);
    });
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  loadData(id) {
    const data = {
      InvitationID: id,
    };
    this.subscriptions.add(this.vmsSrv.getInvitationDetail(data).subscribe((res) => {
        if (res) this.data = res;
     }));
  }

  resendInvite() {
    this.subscriptions.add(this.vmsSrv.resendInvitation(this.id).subscribe((res) => {
        console.log('sent');
    }));
  }

  cancelInvite() {
    this.subscriptions.add(
      this.subscriptions.add(this.vmsSrv.cancelInvitation(this.id).subscribe((res) => {
        if(res.isValid){
          this.router.navigate(['/vms/individual-invite'])
        }

      })))
  }

  formatDate(date, type) {
    if (date == null) return;
    if (type == 'date') {
      this.tempDate = date.split('T')[0].split('-');
      return this.dateSrv.convertDateToLocaleString(this.tempDate[2],this.tempDate[1],this.tempDate[0]);
    }
    if (type == 'time') {
      this.tempDate = date.split('T')[1].split(':');
      return this.tempDate[0] + ':' + this.tempDate[1];
    }
  }
}
